<template>
    <router-link  class="max-w-sm rounded overflow-hidden shadow my-4" style="min-height: 290px" :to="`/articles/${link}`">
    <img class="w-full object-cover h-32" :src="getImage" :alt="title">
          <div class="px-5 py-3">
            <head-line :level="3" :bold="true" :size="5" class="mb-2">{{title}}</head-line>
            <p class="text-gray-600 text-base">
              {{description}}
            </p>
          </div>
          <div class="px-6 py-4" v-if="categories">
            <span
            class="inline-block bg-gray-200 rounded-full px-3 py-1 text-sm font-semibold text-gray-700 mr-2"
            v-for="category in categories" v-bind:key="category">
            {{category}}
            </span>
          </div>
    </router-link>
</template>

<script>
import HeadLine from '@/components/theme/HeadLine'
export default {
   name: "Card",
   props: ['title', 'categories', 'img', 'description', 'link'],
   components: {HeadLine},
   computed: {
    getImage() {
        return 'https://cpanel.awronore.krd' + this.img;
    }
   }

}
</script>

<style>

</style>
